import React from 'react';
import { Clock, LogOut } from 'lucide-react';

/**
 * IdleWarningModal
 * Shows a warning popup when the user is about to be auto-logged out due to inactivity.
 */
const IdleWarningModal = ({ isOpen, remainingSeconds, onStayActive, onLogout }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 w-full max-w-sm mx-4 overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="bg-gradient-to-r from-amber-50 to-orange-50 px-6 py-4 border-b border-amber-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
              <Clock className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <h3 className="text-base font-bold text-slate-800">Session Expiring</h3>
              <p className="text-xs text-slate-500">Due to inactivity</p>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <p className="text-sm text-slate-600 leading-relaxed">
            Your session will expire in{' '}
            <span className="font-bold text-amber-600 text-lg">{remainingSeconds}</span>{' '}
            second{remainingSeconds !== 1 ? 's' : ''} due to inactivity.
          </p>
          <p className="text-xs text-slate-400 mt-2">
            Click "Stay Logged In" to continue your session.
          </p>
        </div>

        {/* Actions */}
        <div className="px-6 pb-5 flex items-center gap-3">
          <button
            onClick={onStayActive}
            className="flex-1 px-4 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
          >
            Stay Logged In
          </button>
          <button
            onClick={onLogout}
            className="flex items-center gap-1.5 px-4 py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-medium rounded-lg transition-colors"
          >
            <LogOut className="w-3.5 h-3.5" />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default IdleWarningModal;
